module.exports = "<div class=orders> <md-card flex> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> <md-progress-linear flex md-mode=indeterminate ng-show=\"c.tableDefinition.settings.promise.$$state.status === 0\"></md-progress-linear> </md-card> <md-card ng-repeat=\"date in c.datesInWeek\" ng-if=\"c.searchResult[date] && c.searchResult[date].length\"> <rkc-orders-table table-title=date table-content=c.searchResult[date] table-definition=c.tableDefinition minimized-on-init=c.isDateNotToday(date)></rkc-orders-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/orders/orders.html
 ** module id = 519
 ** module chunks = 0
 **/